import React from 'react';

const styles = {
  wrapper: {
    minHeight: '100vh',
    backgroundColor: '#F8F9F8',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  header: {
    width: '100%',
    backgroundColor: '#FFFFFF',
    borderBottom: '1px solid #E5E7EB',
    padding: '16px 24px',
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
  },
  wordmark: {
    fontSize: '20px',
    fontWeight: '700',
    color: '#0D0F1F',
    letterSpacing: '-0.3px',
  },
  accent: {
    color: '#2ABFAB',
  },
  label: {
    fontSize: '14px',
    color: '#888888',
    marginLeft: '4px',
  },
  content: {
    width: '100%',
    maxWidth: '680px',
    padding: '32px 24px',
    flex: 1,
  },
  footer: {
    padding: '20px 24px',
    fontSize: '13px',
    color: '#888888',
    textAlign: 'center',
  },
};

const BillingShell = ({ children }) => (
  <div style={styles.wrapper}>
    <header style={styles.header}>
      <span style={styles.wordmark}>
        LifeChi<span style={styles.accent}>AI</span>
      </span>
      <span style={styles.label}>· Billing Management</span>
    </header>
    <main style={styles.content}>{children}</main>
    <footer style={styles.footer}>
      All other features are available in the mobile app.
    </footer>
  </div>
);

export default BillingShell;
